import * as React from 'react';
export const IcAwardBadge = (
  props: React.SVGProps<SVGSVGElement>
): JSX.Element => (
  <svg
    viewBox='0 0 24 24'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
    {...props}
  >
    <path
      d='M19.77 9.36l-.82-1 .32-1.24A1 1 0 0018.71 6l-1.13-.51-.23-1.25a1 1 0 00-1-.82h-1.23l-.73-1a1 1 0 00-1.29-.3l-1.1.59-1.08-.59a1 1 0 00-1.29.3l-.73 1H7.67a1 1 0 00-1 .82l-.25 1.22L5.29 6a1 1 0 00-.56 1.17l.32 1.24-.82 1a1 1 0 000 1.28l.82 1-.32 1.24A1 1 0 005.29 14l1.13.51.23 1.25a1 1 0 00.82.8L7 19.72a2 2 0 003.09 1.94L12 20.4l1.89 1.26A2 2 0 0015 22a2.002 2.002 0 001.98-2.31l-.45-3.13a1 1 0 00.82-.8l.23-1.25 1.13-.51a1 1 0 00.56-1.17L19 11.62l.82-1a1 1 0 00-.05-1.26zm-2.69 1.37a.998.998 0 00-.2.89l.24.93-.84.37a1 1 0 00-.57.74l-.17.92h-.9a1 1 0 00-.85.41l-.53.74-.78-.42a1 1 0 00-1 0l-.78.42-.49-.73a.91.91 0 00-.85-.41h-.9l-.17-.92a1 1 0 00-.57-.74l-.84-.37.24-.93a1 1 0 00-.2-.89L6.31 10l.61-.73a1 1 0 00.2-.89l-.24-.93.84-.37a1 1 0 00.57-.74l.17-.92h.9a.94.94 0 00.85-.42l.53-.74.78.42a1 1 0 001 0l.78-.42.53.74a1 1 0 00.85.41h.9l.17.92a1 1 0 00.57.74l.84.37-.24.93a.999.999 0 00.2.89l.61.73-.65.74zM12 7a3 3 0 100 6 3 3 0 000-6z'
      fill='currentColor'
    />
  </svg>
);
